export const extractPercentAsNumber = (percent?: string): number => {
  if (percent && /%/.test(percent)) {
    return Number(percent.replace(/%/, ''));
  }

  return 0;
};
